import React from 'react'
import "./Main_wallet_cards_section.css"
import Main_wallet_card from './main_wallet_card/Main_wallet_card'
import animationTopUpAmountData from "../../../animations/main_wallet_card_lottie/TopUpAmount.json"
import animationXCappingData from "../../../animations/main_wallet_card_lottie/XCapping.json"
import animationTotalIncomeReceivedData from "../../../animations/main_wallet_card_lottie/Total_Income_Received.json"
import animationTodayIncomeData from "../../../animations/main_wallet_card_lottie/Today's_Income.json"
import Main_wallet_btn_card from './main_wallet_btn_card/Main_wallet_btn_card'
function Main_wallet_cards_section() {
    return (
        <>
            <section className='Main_wallet_cards_section'>
                <div className="row">
                    <div className="col-sm-6">
                        <Main_wallet_card animationData={animationTopUpAmountData} />
                    </div>

                    <div className="col-sm-6">
                        <Main_wallet_card animationData={animationXCappingData} />
                    </div>

                    <div className="col-sm-6">
                        <Main_wallet_card animationData={animationTotalIncomeReceivedData} />
                    </div>

                    <div className="col-sm-6">
                        <Main_wallet_card animationData={animationTodayIncomeData} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <Main_wallet_btn_card animationData={animationTopUpAmountData} />
                    </div>

                    <div className="col-12">
                        <Main_wallet_btn_card animationData={animationXCappingData} />
                    </div>

                    <div className="col-12">
                        <Main_wallet_btn_card animationData={animationTotalIncomeReceivedData} />
                    </div>

                    <div className="col-12">
                        <Main_wallet_btn_card animationData={animationTodayIncomeData} />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main_wallet_cards_section